/* eslint-disable react/prop-types */
import React, { useEffect } from 'react'

// Handles the view of GWS_REVOKE_SESSIONS
function RevokeUserSessions(props) {
  const { action, taskParameters, setCompletedActions, onActionSubmit } = props

  // Handles setting the completed action
  useEffect(() => {
    setCompletedActions((alreadyCompletedActions) => [...alreadyCompletedActions, 'ENGAGE.SIGNED_OUT_ALL_APPS'])

    // Trigger task
    onActionSubmit(action, taskParameters) // Go into loading state while waiting for task completion, then display either success or error body
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  // runs on initial render

  return <></> // eslint-disable-line react/jsx-no-useless-fragment
}

export default RevokeUserSessions
